import constants from "../constants/strings";

export function getStatus(enabled: boolean) {
    return enabled ? constants.ENABLED : constants.DISABLED;
}

export function getEnabledStatus(status: string) {
    return status === constants.ENABLED;
}
